import React from "react";

// Render a programme description.
// - If it's an array, each item becomes a paragraph (or, when it contains
//   " - " separators, a bulleted list).
// - If it's a string, we detect inline " - " separators and split into
//   an intro paragraph + bullet list. Strings without separators render
//   as a normal paragraph.
export function formatDescription(desc) {
  if (desc == null) return null;

  if (Array.isArray(desc)) {
    return (
      <>
        {desc.map((d, i) => (
          <React.Fragment key={i}>{stringToBlocks(d)}</React.Fragment>
        ))}
      </>
    );
  }

  return stringToBlocks(desc);
}

function stringToBlocks(text) {
  if (typeof text !== "string") return null;

  // Split on " - " (a hyphen surrounded by spaces) — the convention used
  // in the source data to indicate list items.
  const parts = text
    .split(/\s-\s+/)
    .map((s) => s.trim())
    .filter(Boolean);

  if (parts.length <= 1) {
    return <p>{text}</p>;
  }

  // If the first chunk ends with ":" or feels like a sentence intro,
  // treat it as a lead-in paragraph; everything after becomes a bullet.
  const [first, ...rest] = parts;
  const introLooksLikeLeadIn = /[:\.]$/.test(first) || first.length < 160;

  return (
    <>
      {introLooksLikeLeadIn && <p>{first}</p>}
      <ul>
        {(introLooksLikeLeadIn ? rest : parts).map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    </>
  );
}
